function notify(target) {
  target.dispatchEvent(new Event('change'));
}

export class HistoryManager extends EventTarget {
  constructor() {
    super();
    this.undoStack = [];
    this.redoStack = [];
    this.transaction = null;
  }

  execute(command) {
    if (!command?.do || !command?.undo) throw new Error('History command requires do and undo functions.');
    command.do();
    if (this.transaction) this.transaction.commands.push(command);
    else this.undoStack.push(command);
    this.redoStack.length = 0;
    notify(this);
  }

  undo() {
    const command = this.undoStack.pop();
    if (!command) return false;
    command.undo();
    this.redoStack.push(command);
    notify(this);
    return true;
  }

  redo() {
    const command = this.redoStack.pop();
    if (!command) return false;
    command.do();
    this.undoStack.push(command);
    notify(this);
    return true;
  }

  beginTransaction(description = 'Grouped edit') {
    if (this.transaction) return;
    this.transaction = { description, commands: [] };
  }

  commitTransaction() {
    const transaction = this.transaction;
    this.transaction = null;
    if (!transaction?.commands.length) return;
    this.undoStack.push({
      description: transaction.description,
      do: () => transaction.commands.forEach((command) => command.do()),
      undo: () => [...transaction.commands].reverse().forEach((command) => command.undo())
    });
    notify(this);
  }

  clear() {
    this.undoStack.length = 0;
    this.redoStack.length = 0;
    notify(this);
  }

  get canUndo() { return this.undoStack.length > 0; }
  get canRedo() { return this.redoStack.length > 0; }
}
